(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["elabs-warranty-addon"] && !Shopify.designMode) return;
  try {
    // Adds the warranty to the same cart request as the Mac (the form posts id + items[0]).
  document.addEventListener('formdata', (event) => {
    const form = event.target;
    // The product form has an input named "id", which shadows form.id: read the attribute.
    const formId = form instanceof HTMLFormElement ? form.getAttribute('id') : null;
    if (!formId) return;

    const checkbox = document.querySelector(
      `.elabs-warranty[data-form-id="${formId}"] .elabs-warranty__checkbox`
    );
    if (!checkbox || !checkbox.checked || event.formData.has('items[0][id]')) return;

    event.formData.append('items[0][id]', checkbox.dataset.variantId);
    event.formData.append('items[0][quantity]', event.formData.get('quantity') || '1');
    event.formData.append('items[0][properties][Mac couvert]', checkbox.dataset.mac);
  });
  } catch(e) { console.error(e); }
})();

})();
